var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},_vm._l((_vm.columns),function(item){return _c('div',{key:item.index},[_c('div',{staticClass:"item"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(item.label))]),_c('theCell',{staticClass:"cell",attrs:{"value":_vm.value,"row":item}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }